export default {
  navigation: {
    homepage: 'Accueil',
    profile: 'Mon profil',
    editProfile: 'Editer mon profil',
    changePassword: 'Changement mot de passe',
    devices: 'Mes appareils',
    services: 'Mes services',
    disableAccess: 'Désactiver l\'accès à une plateforme'
  },
  email: 'E-mail',
  username: 'E-mail, téléphone ou identifiant (INS, RPPS, ...)',
  password: 'Mot de passe',
  newPassword: 'Nouveau mot de passe',
  firstName: {
    view: 'Prénom(s)',
    edition: 'Prénom(s) (ex : Jean, Marc, Victor)'
  },
  lastName: 'Nom de famille',
  birthName: 'Nom de naissance',
  speciality: 'Spécialité',
  category: 'Catégorie',
  address: 'Adresse',
  type: 'Type',
  phone: 'Téléphone portable',
  birthDate: 'Date de naissance (JJ/MM/AAAA)',
  birthDateUser: 'Date de naissance',
  birthPlaceInsee: 'Code INSEE de la ville de naissance',
  birthDateNotSpecified: 'Non renseignée',
  phoneNotSpecified: 'Non renseigné',
  sex: 'Sexe',
  sexChoice: {
    male: 'Homme',
    female: 'Femme',
    unknown: 'Non renseigné'
  },
  gender: 'Genre',
  ins: 'Matricule INS',
  oid: 'OID',
  parentIns: 'Numéro INS du parent',
  myInformations: 'Mes informations personnelles',
  contactInformation: 'Mes informations de contact',
  information: 'Mes informations',
  profile: 'Mon profil',
  passwordChoice: 'Définir mon mot de passe',
  passwordHint: 'Doit contenir au moins 8 caractères, dont 1 chiffre, 1 minuscule et 1 majuscule.',
  patient: {
    label: 'Patient',
    identifier: 'Numéro de sécurité social',
    firstNameUsed: 'Prénom utilisé',
    lastNameUsed: 'Nom utilisé'
  },
  professional: {
    label: 'Professionnel',
    identifier: 'Identifiant (RPPS, ADELI, autre (FINESS, SIRET, SIREN, DRASS))',
    job: 'Métier',
    jobSpecialty: 'Spécialité'
  },
  trustedDevices: {
    title: 'Mes appareils reconnus',
    subtitle: 'Vous retrouverez l\'ensemble des vos appareils reconnus',
    noDevice: 'Aucun appareil reconnu',
    refresh: 'Actualiser',
    userAgent: 'Appareil',
    ip: 'Adresse IP',
    moreDevice: 'Voir mes appareils',
    creationDate: 'Ajouté le',
    lastUsed: 'Dernière utilisation',
    deleteDevice: 'Supprimer cet appareil',
    alert: {
      title: 'Suppression d\'un appareil reconnu',
      content: 'L\'appareil "{userAgent}" ne sera plus considéré comme reconnu et vous devrez donc passer par la double authentification.'
    }
  }
}
